import { buildSignals, markdownCitabilitySignals, scoreFromSignals, type ContentSignals, type CitabilityFields, type CitabilityResult } from '@wordpuppi/shared';
export { fleschReadingEase, scoreFromSignals, type CitabilityFactor, type CitabilityResult, type CitabilityFields, type ContentSignals, type FactorStatus } from '@wordpuppi/shared';

function looksLikeHtml(s: string): boolean { return /<\/?[a-z][\s\S]*>/i.test(s); }

function fromHtml(html: string): ContentSignals {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const levels = Array.from(doc.querySelectorAll('h1,h2,h3,h4,h5,h6')).map((h) =>
    Number(h.tagName[1]),
  );
  const h2 = levels.filter((l) => l === 2).length;
  const h3 = levels.filter((l) => l === 3).length;
  const lists = doc.querySelectorAll('ul,ol').length;
  const outboundLinks = Array.from(doc.querySelectorAll('a[href]')).filter((a) =>
    /^https?:\/\//i.test(a.getAttribute('href') || ''),
  ).length;
  const text = (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
  return buildSignals(text, levels, h2, h3, lists, outboundLinks);
}

export function extractSignals(content: string): ContentSignals {
  const trimmed = content.trim();
  if (!trimmed) {
    return { words: 0, fre: null, h2: 0, h3: 0, headingSkip: false, lists: 0, outboundLinks: 0 };
  }
  return looksLikeHtml(trimmed) ? fromHtml(trimmed) : markdownCitabilitySignals(trimmed);
}

export function scoreCitability(content: string, fields: CitabilityFields): CitabilityResult {
  return scoreFromSignals(extractSignals(content), fields);
}
